import React from 'react';
import styled from 'styled-components';
import StatisticsFilter from './Filter';
import StatisticsChart from './Chart';
import { AIReviewStatisticsItem, StatisticsUnit } from 'services/api/adminStatistics';

interface AIReviewStatisticsTemplateProps {
  // Filter props
  startDate: string;
  endDate: string;
  unit: StatisticsUnit;
  simplifyPremiumRole: boolean;
  excludeUnspecified: boolean;
  groupByStatus: boolean;
  groupByPromptType: boolean;
  groupByUserId: boolean;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onUnitChange: (unit: StatisticsUnit) => void;
  onSimplifyPremiumRoleChange: (checked: boolean) => void;
  onExcludeUnspecifiedChange: (checked: boolean) => void;
  onGroupByStatusChange: (checked: boolean) => void;
  onGroupByPromptTypeChange: (checked: boolean) => void;
  onGroupByUserIdChange: (checked: boolean) => void;
  onSearch: () => void;

  // Chart props
  statistics: AIReviewStatisticsItem[];

  // Actions props
  onCSVDownload: () => void;

  // Common
  loading?: boolean;
}

const AIReviewStatisticsTemplate: React.FC<AIReviewStatisticsTemplateProps> = ({
  startDate,
  endDate,
  unit,
  simplifyPremiumRole,
  excludeUnspecified,
  groupByStatus,
  groupByPromptType,
  groupByUserId,
  onStartDateChange,
  onEndDateChange,
  onUnitChange,
  onSimplifyPremiumRoleChange,
  onExcludeUnspecifiedChange,
  onGroupByStatusChange,
  onGroupByPromptTypeChange,
  onGroupByUserIdChange,
  onSearch,
  statistics,
  onCSVDownload,
  loading = false,
}) => {
  return (
    <Container>
      <FilterSection>
        <StatisticsFilter
          startDate={startDate}
          endDate={endDate}
          unit={unit}
          simplifyPremiumRole={simplifyPremiumRole}
          excludeUnspecified={excludeUnspecified}
          groupByStatus={groupByStatus}
          groupByPromptType={groupByPromptType}
          groupByUserId={groupByUserId}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
          onUnitChange={onUnitChange}
          onSimplifyPremiumRoleChange={onSimplifyPremiumRoleChange}
          onExcludeUnspecifiedChange={onExcludeUnspecifiedChange}
          onGroupByStatusChange={onGroupByStatusChange}
          onGroupByPromptTypeChange={onGroupByPromptTypeChange}
          onGroupByUserIdChange={onGroupByUserIdChange}
          onSearch={onSearch}
          onCSVDownload={onCSVDownload}
          loading={loading}
        />
      </FilterSection>

      <ChartSection>
        <StatisticsChart
          statistics={statistics}
          unit={unit}
          loading={loading}
        />
      </ChartSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
`;

const FilterSection = styled.section`
  width: 100%;
`;

const ChartSection = styled.section`
  width: 100%;
`;

export default AIReviewStatisticsTemplate;
